import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';

import cn from 'classnames';
import { Button } from 'components/UtilElements';
import { AuthAction, AuthActions } from 'containers/AuthStateManager';
import { AuthScreens } from 'globals/constants';
import { Dispatch } from 'redux';
import { UPDATE_ACCESS_DATA } from 'redux/actions';
import { API, request } from 'redux/api';
import { RootState } from 'redux/reducers';

interface ImportMyDataResponse extends MessageResponse {
  userId: string;
  loginId: string;
  emailId: string;
  passwordSet: NumericBoolean;
  useSSO: NumericBoolean;
  ssoAuthUrl: string;
  ssoSessionId: string;
}

const ltiImportMyData = () => {
  return request<ImportMyDataResponse>({
    url: API.LTI_IMPORT_MY_DATA,
    method: 'post',
  });
};

interface ImportMyDataConsentProps {
  accessData: SessionData | null;
  setAuthState(action: AuthAction): void;
  setAccessData(session: SessionData): void;
}

const ImportMyDataConsent: FC<ImportMyDataConsentProps> = ({ accessData, setAccessData, setAuthState }) => {
  const importMyData = useCallback(async () => {
    if (!accessData) {
      return console.warn('Access data is not provided!');
    }

    const { useSSO, ssoAuthUrl, ssoSessionId } = await ltiImportMyData();

    setAccessData({ ...accessData, isImported: 1, useSSO, ssoAuthUrl, ssoSessionId });

    if (useSSO) {
      setAuthState({
        type: AuthActions.SSO_LOGIN,
        payload: AuthScreens.SSO_AUTHENTICATION,
      });
      return;
    }
    setAuthState({
      type: AuthActions.SET_SCREEN,
      payload: AuthScreens.GET_STARTED,
    });
  }, [accessData, setAccessData, setAuthState]);

  if (!accessData) return null;

  return (
    <>
      <h2 className='auth__title'>Can we import your data?</h2>
      <div className='auth__panel'>
        <p className='auth__message'>
          To integrate your Acadly account with your LMS account, we are seeking permission to copy your name
          and email address from your LMS servers into Acadly servers
        </p>
        <div className='auth__action-container'>
          <Button
            variant='outlined'
            color='info'
            size='large'
            className={cn('auth__action')}
            onClick={() => importMyData()}
          >
            YES, IMPORT MY DATA
          </Button>
        </div>
        <p className='auth__note'>
          For the LMS plugin integration to work, it is essential for Acadly to import your data
        </p>
      </div>
    </>
  );
};

const mapStateToProps = ({ getAccess }: RootState) => {
  return { accessData: getAccess };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setAccessData: async (payload: SessionData) => {
      dispatch({ type: UPDATE_ACCESS_DATA, payload });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportMyDataConsent);
